import React, {useCallback, useEffect, useState} from 'react'
import Modal from "../../Modal/Modal";
import {useToast} from "../../../../context/ToastContext";
import useFormValidation from "../../../../hooks/useFormValidation";
import {courseFormSchema} from "../../../../utils/form/validationSchema";
import CourseForm from "../../Forms/CourseForm";

const getDefaultValues = (quantity) => {
    return Array.from({length: quantity}).reduce((acc, curr, i) => {
        acc.emails[i] = "";
        return acc;
    }, {emails: []})
}

function CourseModal({
                         isOpen,
                         onClose,
                         quantity,
    onSubmit
                     }) {
    const [formValues, setFormValues] = useState({emails: []});
    const [loading, setLoading] = useState(false)
    const [formRef, setFormRef] = useState(null)
    const {showToast} = useToast()
    const {validateValues, validateFieldOnChange, errors, resetErrors, setError} = useFormValidation({
        schema: courseFormSchema,
        formRef,
    })

    const validateOnDuplicate = (validatedData) => {
        let result = true;

        const emailMap = new Map();
        validatedData.emails.forEach((email, index) => {
            const lower = email?.toLowerCase();
            if (!lower) return;
            if (emailMap.has(lower)) {
                setError(`emails[${index}]`, 'Duplicate email')
                result = false;
            } else {
                emailMap.set(lower, index);
            }
        });

        return result;
    }

    useEffect(() => {
        setFormValues(getDefaultValues(quantity));
    }, [quantity]);

    const onSubmitForm = useCallback(async () => {
        setLoading(true)

        const validatedData = await validateValues(formValues)

        if (!validatedData) {
            showToast('Validation error', '')
            setLoading(false)
            return
        }

        const result = validateOnDuplicate(validatedData)

        if(!result){
            showToast('Validation error', '')
            setLoading(false)
            return
        }

        setLoading(false)

        onSubmit(validatedData);
        onCloseModal()
    }, [formValues, onSubmit])

    const onChange = useCallback(
        async ({target: {name, value}}) => {
            setFormValues((prev) => {
                const match = name.match(/^(\w+)\[(\d+)\]$/); // matches emails[0]

                if (match) {
                    const [, arrayName, indexStr] = match;
                    const index = parseInt(indexStr);
                    const updatedArray = [...(prev[arrayName] || [])];
                    updatedArray[index] = value;
                    return {...prev, [arrayName]: updatedArray};
                }

                return {...prev, [name]: value};
            })

            await validateFieldOnChange({name, value})
        },
        [errors]
    )

    const onCloseModal = useCallback(() => {
        setFormValues(getDefaultValues(quantity));
        resetErrors()
        setLoading(false)

        onClose()
    }, [onClose])

    return (
        <Modal
            title={"Add Candidate Email Address"}
            subTitle='Complete the short form below. Access to the course will be issued to the specified email.'
            isLoading={loading}
            isOpen={isOpen}
            onClose={onCloseModal}
            onSubmit={onSubmitForm}
            primaryButtonText="Submit"
        >
            <CourseForm
                errors={errors}
                formValues={formValues}
                loading={loading}
                onChange={onChange}
                setFormRef={setFormRef}
            />
        </Modal>
    )
}

export default CourseModal
